import i18n from '@/i18n';

/**
 * Entries retired from the business vocabulary carry `deprecated: true`. Wherever
 * one still surfaces it is labelled from `enums.deprecated.*` instead of the caller's
 * prefix, so the dropdown says out loud that the value is no longer in use. The
 * retired label lives in a single namespace, not in each of the `enums.*`/`samples.*`
 * blocks, because a retired entry reads the same whoever asks for it.
 */
const toOption = (item, prefix) => ({
  label: item.deprecated
    ? `enums.deprecated.${item.value}`
    : `${prefix}.${item.value}`,
  value: item.value,
});

// Users read labels, not keys, so that is what decides the order
const byTranslatedLabel = (a, b) =>
  i18n.t(a.label).localeCompare(i18n.t(b.label), i18n.locale);

/**
 * Builds the option list of an enum-backed select.
 *
 * Retired entries are hidden from new selections but stay available when a record
 * still carries one, so historical samples keep showing their label instead of the
 * raw key.
 */
export function enumOptions(list, prefix, currentValue = null) {
  return list
    .filter((item) => !item.deprecated || item.value === currentValue)
    .map((item) => toOption(item, prefix))
    .sort(byTranslatedLabel);
}

/**
 * Builds the option list of a filter.
 *
 * A filter has to match what the database already holds, so it offers every value
 * ever written, retired ones included — hiding them would make the records that
 * carry them unreachable.
 */
export function filterOptions(list, prefix) {
  return list.map((item) => toOption(item, prefix)).sort(byTranslatedLabel);
}

export default enumOptions;
